/*
  Hero slider for sections/pf-hero-slider.liquid (HANDOFF §3.1, §2.7).

  Autoplays every 6 s (data-interval) and loops. Pauses while the pointer or
  keyboard focus is inside the section, and has an explicit pause/play button.
  Under prefers-reduced-motion it never autoplays and the CSS drops the fade.
  Clicking a tab jumps to that slide and restarts the timer. Arrow keys move
  between tabs (role=tablist). The slide region is aria-live="polite".
*/
(function () {
  'use strict';

  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pf-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pf-tab]'));
    var toggle = root.querySelector('[data-pf-toggle]');
    if (slides.length < 2) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var i = 0, timer = null, paused = reduce, hovering = false;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.hidden = !on;
      });
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var bar = t.querySelector('[data-pf-bar]');
        if (bar) {
          bar.classList.remove('is-running');
          void bar.offsetWidth; /* restart the CSS progress animation */
          bar.style.animationDuration = interval + 'ms';
          bar.classList.toggle('is-running', on && !paused && !hovering);
        }
      });
    }

    function tick() { show(i + 1); }
    function start() {
      stop();
      if (paused || hovering) return;
      timer = setInterval(tick, interval);
      show(i);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); start(); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (k + d + tabs.length) % tabs.length;
        tabs[n].focus();
        show(n); start();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        paused = !paused;
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.textContent = paused ? toggle.getAttribute('data-play') : toggle.getAttribute('data-pause');
        if (paused) { stop(); show(i); } else { start(); }
      });
      if (reduce) {
        toggle.setAttribute('aria-pressed', 'true');
        toggle.textContent = toggle.getAttribute('data-play');
      }
    }

    root.addEventListener('mouseenter', function () { hovering = true; stop(); show(i); });
    root.addEventListener('mouseleave', function () { hovering = false; start(); });
    root.addEventListener('focusin', function () { hovering = true; stop(); show(i); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { hovering = false; start(); }
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pf-slider]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
